import { getSnowplowTracker } from '@common/Tracking/helpers/tracker';
import { isIntersectionObserverSupported } from '@helpers/browser';
import { handleProductImpression } from './handlers';
import Impressions from './Impressions';

let productImpressionsInstance;

export const trackProductImpressions = (container) => {
    const tracker = getSnowplowTracker();

    if (
        !App?.Feature?.isActive('T49115_product_impressions')
        || !isIntersectionObserverSupported()
        || typeof tracker !== 'function'
    ) {
        return undefined;
    }

    if (!productImpressionsInstance) {
        productImpressionsInstance = new Impressions(
            'impressions-observer',
            'impression-product',
            tracker,
            handleProductImpression
        );

        productImpressionsInstance.init();
    }

    if (container) {
        productImpressionsInstance.registerContainer(container);
    }

    return productImpressionsInstance;
};
